export default {
  BUTTON: {
    APPLY: 'Apply',
    NONE: 'None',
    SAVE_CHANGES: 'Save Changes',
    PROCEED: 'Proceed',
    DISMISS: 'Dismiss',
    CONNECT: 'Connect',
    CONNECT_WALLET: 'Connect Wallet',
    DISCONNECT: 'Disconnect',
    LOGOUT: 'Logout',
    CLOSE: 'Close',
    SETTINGS: 'Settings',
    LAUNCH_APP: 'Launch App',
    CONNECT_TO_PROCEED: 'Connect Wallet',
    VIEW_DETAILS: 'View Details',
    REFRESH: 'Refresh',
    START_REGISTRATION: 'Start Registration',
    CANCEL: 'Cancel',
    PRESS_ENTER: 'Press Enter',
    LEARN_MORE: 'Learn More',
    CLOSE_WINDOW: 'Close Window',
    SHOW_AVAILABLE_ONLY: 'Show Available Only',
    SHOW_AVAILABLE: 'Show Available',
    PROCEED_SEARCH: 'Proceed Search',
    DOWNLOAD: 'Download',
    SHOW_ALL: 'Show All',
    DESELECT_ALL: 'Deselect All',
    SHOW_SELCTED: 'Show Selected',
    LINK: 'Link',
    CUSTOM_LINK: 'Custom Link',
    SET_QR_LINK_ALL: 'Set QR Link All',
    SET_QR_LINK: 'Set QR Link',
    DISABLE_ALL: 'Disable All',
    DISABLE_QR_CODE: 'Disable QR Code',
    ENABLE_QR_CODE: 'Enable QR Code',
    SET_QR_COLOR: 'Set QR Color',
    SET_COLOR: 'Set Color',
    SET_ALL_COLORS: 'Set All Colors',
    SET_PRICE: 'Set Price',
    SET_PRICE_ALL: 'Set Price All',
    RESET: 'Reset',
    CHECK_PROFILE: 'Check Profile',
    GO_TO_DASHBOARD: 'Go to Dashboard',
    GO_TO_HOME: 'Go To Home',
    VIEW_PROFILE: 'View Profile',
    CHECK_DOMAINS: 'Check Domains',
    TRANSACTION_DETAILS: 'Transaction Details',
    BUY_NOW: 'Buy Now',
    CLEAR_HISTORY: 'Clear History',
    DEFAULT: 'Default',
    CUSTOM: 'Custom',
    FRACTIONALISE: 'Fractionalise',
    MORE_INFO: 'More Info',
    LESS_INFO: 'Less Info',
    APPROVE: 'Approve',
    NEXT: 'Next',
    PENDING: 'Pending',
    REMOVE: 'Remove',
    REMOVE_ALL_ITEMS: 'Remove All Items',
    ADD_ALL_TO_CART: 'Add All To Cart',
    BOOKMARK_ALL: 'Bookmark All',
    DOWNLOAD_LIST: 'Download List',
    SHARE_LIST: 'Share List',
    MORE: 'More',
    CHANGE: 'Change',
    TRY_AGAIN: 'Try Again',
  },
  HEADER: {
    ABOUT: 'About',
    FAQ: 'FAQs',
    BACK_TO_HOME: 'Back to Home',
    HOME: 'Home',
    CATEGORIES: 'Categories',
    HELP_SUPPORT: 'Help & Support',
    HELP: 'Help',
    CANCEL_REGISTRATION: 'Cancel Registration',
    PROFILE: 'Profile',
    SETTINGS: 'Settings',
    DOCS: 'Docs',
    DOCUMENTATIONS: 'Documentations',
    CART: 'Cart',
    BOOKMARKS: 'Bookmarks',
    PAYMENTS_HISTORY: 'Payments History',
    LIGHT_MODE: 'Light Mode',
    CUSTOM_RPC: 'Custom RPC',
    SETUP_REQUIRED: 'Setup Required',
    MANAGE_DOMAINS: 'Manage Domains',
    APPROVE: 'Approve',
    FEATURE_DISABLED: 'Feature Disabled',
    ERROR: 'Error',
  },
  IPFS: {
    INITIALISING: 'Starting p2p',
    FINDING_PEERS: 'Finding peers',
    FAILED: 'Failed',
    READY: 'Ready',
    PUBLISHING: 'Publishing',
  },
  EVENTS: {
    TRANSFER: 'Transfer',
    REGISTRATION: 'Registration',
    RENEWAL: 'Renewal',
    SALE: 'Sale',
    MINT: 'Mint',
    BURN: 'Burn',
  },
  GENERIC: {
    NETWORK_CHANGED_INCOMPATIBLE:
      'Network is not supported. Please change your network.',
    IPNS_PUBLISHING_COMPLETED: 'Publishing completed!',
    PENDING_TRANSACTION_CERATED:
      'A new transaction has been created. Please check your wallet.',
  },
  RENEWAL_DURATIONS: {
    ONE_WEEK: '1 Week',
    ONE_MONTH: '1 Month',
    THREE_MONTHS: '3 Months',
    SIX_MONTHS: '6 Months',
    ONE_YEAR: '1 Year',
    TWO_YEARS: '2 Years',
    THREE_YEARS: '3 Years',
    FOUR_YEARS: '4 Years',
    FIVE_YEARS: '5 Years',
  },
  LABELS: {
    DOWNLOAD_DATA: 'Download Data',
    SORT_BY_EXPIRATIONS: 'Sort By Expirations',
    SORT_BY_LATEST_REGISTRATIONS: 'Sort By Latest Registrations',
    SORT_BY_LONGEST_DURATION: 'Sort By Longest Reg. Duration',
    PREMIUM: 'Premium',
    ANALYTICS: 'Analytics',
    AN_ERROR_HAS_OCCURED: 'An error has occured while processing your request.',
    STOREFRONT_READY_TO_DEPLOY:
      'Your store front is ready to be deployed. Your store will be located at:',
    ACCESS_STOREFRONT: 'You can now access your store front at:',
    BUY_ON: 'Buy on',
    MY_PROFILE: 'My Profile',
    CREATE_STOREFRONT: 'Create Storefront',
    SETUP_PRIMARY_DOMAIN: 'Setup Primary Domain',
    CHOOSE_A_PRIMARY_DOMAIN:
      'Choose a primary domain and link it to your profile. This chosen domain will be your profile link.',
    CREATE_YOUR_STOREFRONT:
      'Create your store front using your .eth name with Predomain Stores. Learn more about your store front at:',
    THIS_DOMAINS_IS_AVAILABLE_IN_MARKETPLACE:
      'This domain is available on the following marketplaces',
    PURCHASE_DOMAINS: 'Purchase Domains',
    OWNED_BY: 'Owned By',
    SETUP_STOREFRONT: 'Setup Storefront',
    MANAGE_FEATURED_ITEMS: 'Manage Featured Items',
    VISIT_STOREFRONT: 'Visit Storefront',
    OPTIONS: 'Options',
    FEATURED_ITEMS: 'Featured Items',
    SORT_BY_CATEGORY: 'Sort By Category',
    SELECT_DOMAIN: 'Select Domain',
    SELECT_DOMAINS: 'Select Domains',
    RENEW_DOMAINS: 'Renew Domains',
    TRANSFER_DOMAINS: 'Transfer Domains',
    BUYER: 'Buyer',
    PRICE: 'Price',
    SALE: 'Sale',
    ACTIVITY: 'Activity',
    TOP_CATEGORIES: 'Top Categories',
    TOTAL_ASSETS: 'Total Assets',
    MONTHLY_SALES: 'Monthly Sales',
    DAILY_VOLUME: 'Daily Volume',
    MONTHLY_VOLUME: 'Monthly Volume',
    DAILY_SALES: 'Daily Sales',
    TOP_SALE: 'Top Sale',
    TOP_SALES: 'Top Sales',
    TOP_BUYER: 'Top Buyer',
    RECENT_SALES: 'Recent Sales',
    SALES_ACTIVITY: 'Sales Activity',
    ENTER_NAMES_TO_SEARCH: 'Enter names to search',
    NOT_AVAILABLE: 'Not Available',
    VOLUME: 'Volume',
    FLOOR: 'Floor',
    FILTER: 'Filter',
    RENEWAL_DURATION: 'Renewal Duration',
    TRANSACTION: 'Transaction',
    USER_PROFILE: 'User Profile',
    FEATURE_DISABLED: 'This feature is currently disabled.',
    COMPLETE: 'Complete',
    ESTIMATED_COST: 'Estimated Cost',
    ADDRESS: 'Address',
    TRANSFER: 'Transfer',
    PLEASE_WAIT: 'Please wait',
    SELECT_A_DOMAIN: 'Select a Domain',
    RENEW: 'Renew',
    MANAGE_DOMAINS: 'Manage Domains',
    SEARCH_FOR: 'Search For',
    MANAGE: 'Manage',
    COLLECT: 'Collect',
    LANDING_TEXT:
      'Open-source, decentralised, Web3 domains search, registration & marketplace.',
    PROFILE: 'Profile',
    GO_TO_PROFILE: 'Go to Profile',
    SEARCH: 'Search',
    CONTAIN_ALPHABET: 'Contain Alphabet',
    CONTAIN_NUMBERS: 'Contain Numbers',
    CONTAIN_EMOJI: 'Contain Emoji',
    MIN_LENGTH: 'Min. Length',
    MAX_LENGTH: 'Max. Length',
    CONTAINING_KEYWORDS: 'Containing Keywords',
    FILTERS: 'Filters',
    DOMAINS: 'Domains',
    DOMAIN: 'Domain',
    DOMAIN_HISTORY: 'Domain History',
    EXPIRATION_DATE: 'Expiration Date',
    REGISTRATION_DATE: 'Registration Date',
    CREATION_DATE: 'Creation Date',
    DETAILS: 'Details',
    YOUR_DOMAINS: 'Your Domains',
    PROCESSING: 'Processing',
    LAYOUT: 'Layout',
    ENTER_SUFFIX: 'Enter suffix',
    ENTER_PREFIX: 'Enter prefix',
    CLICK: 'Click',
    CONNECT_TO_START: ' to get started or ',
    TIP: 'Tip',
    ACTION: 'Action',
    ACTIONS: 'Actions',
    ADVANCED_SEARCH_TIP:
      'use new line or commas to seperate your domain entries.',
    ADVANCED_SEARCH: 'Advanced Search',
    ADVANCED_MODE: 'Advanced Mode',
    REGISTER_DOMAINS_TO: 'Register Domains To',
    NO_DOMAINS_SELECTED: 'No domains selected.',
    FIND_AND_REGISTER: 'Register domains e.g. domain1, domain2...',
    SELECTED_DOMAINS: 'Selected Domains',
    REGISTER: 'Register',
    BOOKMARKS: 'Bookmarks',
    SEARCH_RESULTS: 'Search Results',
    PROCEED_TO_REGISTRATION: 'Proceed To Registration',
    REGISTER_DOMAINS: 'Register Domains',
    REGISTRANT_ADDRESS: 'Registrant Address',
    SET_RESOLVER: 'Set Resolver',
    TOTAL_COST: 'Total Cost',
    GAS_PRICE: 'Gas Price',
    NO_ADDRESS_DETECTED: 'No address detected.',
    DURATION: 'Duration',
    NOTICE_SELECT_AN_RPC:
      'Notice: select an RPC that will be used in the application to replace the default RPC provider.',
    ENABLE_LIGHT_MODE: 'Enable light layout style.',
    CLICK_NEXT_TO_PROCEED: 'Click <b>Next</b> to proceed.',
  },
  REGISTRATION: {
    REGISTRATION_CANCELLED_TITLE: 'Registration Cancelled',
    REGISTRATION_CANCELLED_DESCRIPTION: 'Your registration has been cancelled.',
    CANCEL_REGISTRATION_TITLE: 'Cancel Registration',
    CANCEL_REGISTRATION_DESCRIPTION:
      'Are you sure you want to cancel this registration? This action cannot be undone.',
    BEFORE_COMMIT: 'Step 1: request registration.',
    COMMIT_SENT: 'Processing request...',
    COMMIT_COMPLETE: 'Step 1: request registration received...',
    AWAIT: 'Finalising request...',
    BEFORE_REGISTRATION: 'Complete registration.',
    REGISTRATION_SENT: 'Completing registration...',
    REGISTRATION_COMPLETE: 'Registration complete!',
    REGISTRATION_COMPLETE_TITLE: 'Registration Complete',
    YOUR_DOMAINS_HAVE_NOW_BEEN_REGISTERED:
      'Your domains have now been registered.',
    BASKET_EMPTY: 'Your basket is empty',
    PLEASE_SELECT_DOMAINS_TO_REGISTER: 'Please select new domains to register.',
  },
  PAYMENT: {
    PAYMENT_CANCELLED: 'Transaction cancelled. Please try again.',
  },
  SPINNER: {
    SETUP_COMPLETE: 'Setup Complete',
    LEDGER_NO_DEVICE_SELECTED:
      'An error has occured while connecting to your wallet. Please try again.',
    NO_DATA_TO_DISPLAY: 'No items to display.',
    PERFORMING_SEARCH: 'Performing search...',
    LOADING_DATA: 'Loading Data...',
    FOLLOW_THE_INSTRUCTIONS_ON_YOUR_WALLET:
      'Please follow the instructions in your wallet to proceed.',
  },
  FORM_LABELS: {
    ENTER_DURATION: 'Enter Duration',
    ENTER_QR_LINK: 'Enter custom QR Code URL',
    ENTER_PRICE: 'Enter price',
    ENTER_CUSTOM_ADDRESS: 'Enter custom address',
    ENTER_RECEIVER_ADDRESS: 'Enter Receiver Address',
  },
  FORM_ERRORS: {
    INVALID_DURATION: 'Invalid Duration',
    INVALID_QR_LINK: 'Invalid URL, please try again.',
    INVALID_PRICE: 'Invalid price, please try again.',
    NO_ADDRESS_DETECTED: 'No address detected, please try again.',
    INVALID_ADDRESS: 'Invalid address, please try again.',
  },
  STEP: {
    STEP_1: 'Step 1',
    STEP_2: 'Step 2',
    STEP_3: 'Step 3',
    STEP_4: 'Step 4',
    STEP_5: 'Step 5',
  },
  RENEW: {
    RENEWAL_COST: 'Renewal Cost',
    ESTIMATED_RENEWAL_COST:
      'Below is the estimated renewal cost for this transaction.',
    RENEWAL_COMPLETE: 'Renewal Complete',
    DOMAINS_READY_FOR_RENEWAL:
      ' Your domains are now ready renewal. To complete your renewal press proceed.',
  },
  TRANSFER: {
    TRANSFER_TO: 'Transfer to',
    TRANSFER_COMPLETE: 'Transfer Complete!',
    SETUP_INSTRUCTION:
      'To enabled ENS domains management, your account must be configured to approve domain transfers.',
    CONTRACT_APPROVAL_NOTE:
      'Contract approval allows the contract to perform transferring of domains on your behalf.',
    DOMAINS_READY_FOR_TRANSFER:
      "Your domains are now ready for transfer. Enter the reciever's address and press proceed.",
  },
};
